var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',_vm._l((_vm.size),function(i){return _c('Row',{key:i},[_c('td',{staticClass:"table-body-loading",style:({animationDelay: `${i/5}s`}),attrs:{"colspan":"100%"}})])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }